import React from 'react'
import {useState, useContext, useEffect} from 'react'
import {useQuery} from 'react-query'
import {FeedbackContext} from '../../../../Components/Context/FeedbackContext'
import {Loading} from '../../../../Components/Loading/Loading'
import {ErrorConnection} from '../../../../Components/Error/Error'
import {Spinner} from 'react-bootstrap'
import * as Api from '../../../../api/Api'
import {useGetToken} from '../../../../Hooks/CustomHooks'
import * as Utilities from '../../../../Components/Utils/Utils'
import $ from 'jquery'
import {Helmet} from 'react-helmet'
import '../mapplic.css'
import Modal from 'react-bootstrap/Modal'

function VistaGeneral_indVta({unidadEconomica}) {
  const [mapplicObj, setMapplicObj] = useState(null)
  const token = useGetToken()
  const [smShow, setSmShow] = useState(false)
  const [currentIndicadorIndVta, setCurrentIndicadorIndVta] = useState({
    title: null,
    indicadores: {
      ventaDiaAnteriorM2: null,
      ventaDiaAnterior: null,
      area: null,
      ventaM2MesActual: null,
      ventaM2MesAnterior: null,
      promedioVentaMesActual: null,
      ventaMesAnterior: null,
    },
  })

  const listColor = ['#e74157', '#ed7f00', '#f4e21a', '#dee92c', '#afd62b', '#87c141']

  const {feedbackContext, setFeedbackContext} = useContext(FeedbackContext)
  let {data, isLoading, isError, error, isFetching} = useQuery(
    [
      'MapaCalorVistaGeneral_indVta',
      {
        unidadEconomica: unidadEconomica.value,
      },
    ],
    async () =>
      await Api.MapaCalorVistaGeneral_IndicadorVentas({
        unidadEconomicaId: unidadEconomica.value,
      }),
    {
      enabled: true,
    }
  )

  useEffect(() => {
    if (data) {
      if (data.data === null) {
        setFeedbackContext({...feedbackContext, showError: true, idError: data.errorId})
      } else {
        setJsonMapFinalwithSettings(data.data.dataMapa, data.data.dataAux.rangos)
      }
    }
  }, [data])

  let coordenadasTemp = []
  document.addEventListener(
    'keyup',
    (e) => {
      if (e.altKey && e.shiftKey && String.fromCharCode(e.keyCode) == 'C') {
        console.log('locationList', locationList)
        console.log(coordenadasTemp)
      }
    },
    false
  )

  const locationList = []
  function setJsonMapFinalwithSettings(jsonResponseFromServer, rangos) {
    const settings = {
      mapwidth: '1300',
      mapheight: '1000',
      defaultstyle: 'normal',
      styles: [],
      groups: [],
    }

    rangos.forEach(function (currentValue, index, array) {
      settings.styles.push({
        class: 'statusClass' + (index + 1),
        base: {
          fill: listColor[index],
          'fill-opacity': '0.4',
        },
        hover: {
          'fill-opacity': '0.8',
        },
        active: {
          fill: 'green',
          'fill-opacity': '1',
        },
      })
      settings.groups.push({
        id: 'statusCategory' + (index + 1),
        title: currentValue,
        color: listColor[index],
        legend: 'true',
        style: 'statusClass' + (index + 1),
      })
    })

    let data = jsonResponseFromServer

    data.levels.forEach(function (element, index1, array) {
      if (parseInt(element.id) < 0) element['title'] = 'Sótano ' + Math.abs(parseInt(element.id))
      element['map'] =
        '/../mapas/' +
        unidadEconomica.label.toLowerCase().replace(/\s/g, '') +
        '/piso_' +
        element.id +
        '.svg'

      element.locations.forEach(function (elementLocation, index2, array) {
        elementLocation['pin'] = 'hidden'
        elementLocation['titleModal'] = elementLocation['title']
        let indxRango = 0
        for (indxRango; indxRango < rangos.length; indxRango++) {
          if (rangos[indxRango] == elementLocation.rango) {
            elementLocation['category'] = 'statusCategory' + (indxRango + 1)
            elementLocation['style'] = 'statusCategory' + (indxRango + 1)
            elementLocation['title'] =
              elementLocation['title'].length > 10
                ? elementLocation['title'].slice(0, 10) + '...'
                : elementLocation['title']
            break
          }
        }
        //elementLocation["description"] = Utilities.getHtml_mapaCalor_VistaGeneral("", elementLocation.indicadores);
      })
    })

    let returnedTarget = Object.assign(data, settings)
    let mapplicObjTemp = {
      source: returnedTarget,
      height: 'auto',
      // minimap: true,
      lightbox: false,
      sidebar: false,
      hovertip: true,
      maxscale: 10,
      developer: true,
      highlight: true,
      zoom: true,
      mousewheel: true,
      closezoomout: true,
      thumbholder: true,
    }

    //#region Funcion Colorea Bloque
    setTimeout(function () {
      $('.mapplic-pin').each(function (index) {
        $(this).css('background-color', 'white')
      })
    }, 1000)

    let encontrados = 0
    let locationNull = false

    function setColorLocatarios_detectXY() {
      data.levels.map((level, indexLevel) => {
        level.locations.map((location, indexLocation) => {
          let styleTemp = ``
          const positionColor = rangos.findIndex((rango) => rango === location.rango)
          styleTemp = `background-color: ${listColor[positionColor]} !important;fill: ${listColor[positionColor]} !important;`

          $('#' + location.id).attr('style', styleTemp)
          $('#' + location.id).attr('data-toggle', 'tooltip')
          $('#' + location.id).attr('data-placement', 'Tooltip on top')
          $('#' + location.id).attr('data-bs-html', 'true')
          $('#' + location.id).attr('title', location.title)

          let locations = document.getElementsByClassName('cls-4')
          for (let i = 0; i < locations.length; i++) {
            locations[i].addEventListener('click', function (e) {
              let x = $('.mapplic-coordinates-x').html()
              let y = $('.mapplic-coordinates-y').html()
              let elementTemp = {id: e.target.id, x: x, y: y}

              if (locationList.length > 0) {
                var findLocation = locationList.find((location) =>
                  elementTemp.id == location.id ? true : false
                )
              }
              if (!findLocation) locationList.push(elementTemp)

              e.stopPropagation()
            })
          }

          document.addEventListener('click', function (e) {
            if (e.target && e.target.id == location.id) {
              // setSmShow(true);
              //setCurrentIndicadorIndVta({ ...location.indicadores, title: location.title });
              // let x = $(".mapplic-coordinates-x").html();
              // let y = $(".mapplic-coordinates-y").html();
              // let elementTemp = { id: location.id, x: x, y: y };
              // let found = coordenadasTemp.find(function (element) {
              //     return element.id == location.id;
              // });
              // if (found == null) coordenadasTemp.push(elementTemp);
            }
          })
        })
      })
    }
    function setColorLocatarios() {
      console.log('data.levels', data.levels)
      for (let indexLevel = 0; indexLevel < data.levels.length; indexLevel++) {
        if (locationNull && encontrados < 3) break
        const element = data.levels[indexLevel]

        for (let indexLocation = 0; indexLocation < element.locations.length; indexLocation++) {
          if (locationNull && encontrados < 3) break
          const elementLocation = element.locations[indexLocation]

          locationNull = $('#' + elementLocation.id).length == 0
          if (!locationNull) encontrados++
          // else console.log(elementLocation.id, $("#" + (elementLocation.id)).length);

          let styleTemp = ``
          let indxColor = 0
          for (indxColor; indxColor < rangos.length; indxColor++) {
            if (rangos[indxColor] == elementLocation.rango) {
              styleTemp = `background-color: ${listColor[indxColor]} !important;fill: ${listColor[indxColor]} !important;`
              break
            }
          }

          $('#' + elementLocation.id).attr('style', styleTemp)
          $('#' + elementLocation.id).attr('data-toggle', 'tooltip')
          $('#' + elementLocation.id).attr('data-placement', 'Tooltip on top')
          $('#' + elementLocation.id).attr('data-bs-html', 'true')

          //$("#" + (elementLocation.id)).attr("title", `<div><h4>Hola</h4><p>asd</p></div>`);
          $('#' + elementLocation.id).attr(
            'title',
            elementLocation.id + ' : ' + elementLocation.titleModal
          )

          // $("#" + elementLocation.id).on("click touchstart", function () {
          document.addEventListener('click', function (e) {
            if (e.target && e.target.id == elementLocation.id) {
              console.log('click')
              setSmShow(true)
              setCurrentIndicadorIndVta({
                ...elementLocation.indicadores,
                title: elementLocation.id + ' : ' + elementLocation.titleModal,
              })

              let x = $('.mapplic-coordinates-x').html()
              let y = $('.mapplic-coordinates-y').html()
              let elementTemp = {id: elementLocation.id, x: x, y: y}

              // let found = coordenadasTemp.find(function (element) {
              //     return element.id == elementLocation.id;
              // });

              // if (found == null) coordenadasTemp.push(elementTemp);
            }
          })
          // $(document.body).on("click", `#${elementLocation.id}`, function () {
          //     console.log('click')
          //     setSmShow(true);
          //     setCurrentIndicadorIndVta({ ...elementLocation.indicadores, title: elementLocation.title });

          //     let x = $(".mapplic-coordinates-x").html();
          //     let y = $(".mapplic-coordinates-y").html();
          //     let elementTemp = { id: elementLocation.id, x: x, y: y };
          //     console.log('x', elementTemp)

          //     // let found = coordenadasTemp.find(function (element) {
          //     //     return element.id == elementLocation.id;
          //     // });

          //     // if (found == null) coordenadasTemp.push(elementTemp);
          // });
        }
      }

      if (locationNull)
        setTimeout(function () {
          locationNull = false
          setColorLocatarios()
        }, 1500)
    }

    setTimeout(function () {
      setColorLocatarios()
    }, 1500)

    //#endregion

    setMapplicObj(mapplicObjTemp)
  }

  if (isLoading) return <Loading />
  if (isError) return <ErrorConnection error={error} />
  return (
    <>
      {isFetching ? (
        <Spinner animation='grow' variant='secondary' />
      ) : data?.data && data?.data?.dataMapa?.levels.length > 0 ? (
        <>
          <div className='application'>
            <Helmet>
              <script>
                {`
                                        if (` +
                  JSON.stringify(mapplicObj) +
                  ` != null) {
                                            $('#mapplic_container_all_in').mapplic(` +
                  JSON.stringify(mapplicObj) +
                  `);
                                            // $('#mapplic_container_all_in').on("click",
                                            // function(e) {
                                            //     let x = $(".mapplic-coordinates-x").html();
                                            //     let y = $(".mapplic-coordinates-y").html();
                                            //     console.info($(e.target).attr("id") + '|'+ x + '|' + y);
                                            // });
                                            setTimeout(function () {
                                                $('[data-toggle="tooltip"]').tooltip({ container: 'body' })
                                            }, 2000)
                                        }
                                    `}
              </script>
            </Helmet>
          </div>

          <Modal
            show={smShow}
            aria-labelledby='contained-modal-title-vcenter'
            centered
            onHide={() => setSmShow(false)}
          >
            <Modal.Header className='header-personalizable' closeButton>
              <Modal.Title id='contained-modal-title-vcenter'>
                {currentIndicadorIndVta.title}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className='text-center'>
                <h1 className='fw-bold text-gray-800 text-center lh-lg'>
                  Area:
                  <span className='fw-boldest'>
                    {' '}
                    {Utilities.comillasFix(currentIndicadorIndVta.area, true)} m<sup>2</sup>
                  </span>
                </h1>
              </div>
              <div className='row '>
                <div className='col-xl-6'>
                  <div className='d-flex align-items-center bg-light-info rounded p-5'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>Venta</div>
                      <span className='text-muted fw-bold d-block '>Día Anterior</span>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      S/ {Utilities.comillasFix(currentIndicadorIndVta.ventaDiaAnterior, true)}
                    </span>
                  </div>
                </div>
                <div className='col-xl-6'>
                  <div className='d-flex align-items-center bg-light-info rounded p-5'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>
                        Venta x m<sup>2</sup>
                      </div>
                      <span className='text-muted fw-bold d-block '>Día Anterior</span>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      S/ {Utilities.comillasFix(currentIndicadorIndVta.ventaDiaAnteriorM2, true)}
                    </span>
                  </div>
                </div>
              </div>
              <div className='row mt-4'>
                <div className='col-xl-6'>
                  <div className='d-flex align-items-center bg-light-info rounded p-5'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>
                        Venta x m<sup>2</sup>{' '}
                      </div>
                      <span className='text-muted fw-bold d-block '>Mes Actual</span>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      S/ {Utilities.comillasFix(currentIndicadorIndVta.ventaM2MesActual, true)}
                    </span>
                  </div>
                </div>
                <div className='col-xl-6'>
                  <div className='d-flex align-items-center bg-light-info rounded p-5'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>
                        Venta x m<sup>2</sup>
                      </div>
                      <span className='text-muted fw-bold d-block '>Mes Anterior</span>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      S/ {Utilities.comillasFix(currentIndicadorIndVta.ventaM2MesAnterior, true)}
                    </span>
                  </div>
                </div>
              </div>
              <div className='row mt-4'>
                <div className='col-xl-6'>
                  <div className='d-flex align-items-center bg-light-info rounded p-5'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>Prom Venta</div>
                      <span className='text-muted fw-bold d-block '>Mes Actual</span>
                    </div>
                    <span className='fw-bolder text-red-mall py-1 '>
                      S/{' '}
                      {Utilities.comillasFix(currentIndicadorIndVta.promedioVentaMesActual, true)}
                    </span>
                  </div>
                </div>
                <div className='col-xl-6'>
                  <div className='d-flex align-items-center bg-light-info rounded p-5'>
                    <div className='flex-grow-1 me-2'>
                      <div className='text-gray-800 fs-6 fw-bolder'>Venta </div>
                      <span className='text-muted fw-bold d-block '>Mes Anterior</span>
                    </div>
                    <span className='fw-bolder text-blue py-1 '>
                      S/ {Utilities.comillasFix(currentIndicadorIndVta.ventaMesAnterior, true)}
                    </span>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <div id='mapplic_container_all_in'></div>
        </>
      ) : (
        <div class='alert alert-warning' role='alert'>
          Actualmente no existen datos de ventas para este Mall.
        </div>
      )}
    </>
  )
}

export default VistaGeneral_indVta
